import { useEffect, useState } from "react";
import { database } from "../../firebase_config";
import { ref, onValue } from 'firebase/database';
import { getCurrentMonth, getPreviousMonth } from "./getDate";

export const FetchStatisticsData = () => {
    const [revenueState, setRevenueState] = useState(null);
    const [previousMonthRevenue, setPreviousMonthRevenue] = useState(null);

    const [averageCheck, setAverageCheck] = useState(null);
    const [previousMonthAverageCheck, setPreviousMonthAverageCheck] = useState(null);

    const [amountOfOrders, setAmountOfOrders] = useState(null);
    const [previousAmountOfOrders, setPreviousAmountOfOrders] = useState(null);

    const StatisticalArrData = [
        {
            name: "Total revenue",
            value: revenueState,
            icon: 
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                </svg>,
            previousMonthValue: previousMonthRevenue
          
        },
        {
            name: "Average Check",
            value: averageCheck,
            icon: 
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>,
            previousMonthValue: previousMonthAverageCheck
      
        },
        {
            name: "Amount of Orders",
            value: amountOfOrders,
            icon: 
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
                </svg>,
            previousMonthValue: previousAmountOfOrders
      
        },
        {
            name: "My Rating",
            value: 4.7,
            icon: 
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                </svg>,
            previousMonthValue: 4
        }
      ]
    useEffect(() => {

        onValue(ref(database, `statistics/${getCurrentMonth()}/revenue`), (snapshot) => {
            const data = snapshot.val();
            data === 0 ? setRevenueState(0) : setRevenueState(data);
        });

        onValue(ref(database, `statistics/${getPreviousMonth()}/revenue`), (snapshot) => {
            const data = snapshot.val();
            data === 0 ? setPreviousAmountOfOrders(0) : setPreviousMonthRevenue(data);
        });
        
        onValue(ref(database, `statistics/${getCurrentMonth()}/averageCheck`), (snapshot) => {
            const data = snapshot.val();
            data === 0 ? setAverageCheck(0) : setAverageCheck(data);

        });
        onValue(ref(database, `statistics/${getPreviousMonth()}/averageCheck`), (snapshot) => {
            const data = snapshot.val();
            data === 0 ? setPreviousMonthAverageCheck(0) : setPreviousMonthAverageCheck(data);
        });

        onValue(ref(database, `orders/${getCurrentMonth()}`), (snapshot) => {
            const data = snapshot.val();
            data === null ? setAmountOfOrders(0) : setAmountOfOrders(Number.parseInt(Object.keys(data).length-1).toFixed(0));

        });
        onValue(ref(database, `orders/${getPreviousMonth()}`), (snapshot) => {
            const data = snapshot.val();
            data === null ? setPreviousAmountOfOrders(0) :setPreviousAmountOfOrders(Number.parseInt(Object.keys(data).length-1).toFixed(0));
        });
    }, []);

    return StatisticalArrData;
}